import {Text} from '@mantine/core';
import type {FC} from 'react';
import {GTAG_EVENT_NAMES} from '../../../../config/constants/gtag';
import type {GetEntryReadyRecommendsResponse} from '../../../../core/entities/recruitment/schema';
import {PromptModal} from '../../../../shared/components/PromptModal';
import {useImpressionGtagEvent} from '../../../../shared/services/useImpressionGtagEvent';
import {PostRegisterEntryPromptCard} from './PostRegisterEntryPromptCard';

export const POST_REGISTER_ENTRY_PROMPT_COMPONENT_ID =
  'post-register-entry-prompt';

type Props = {
  opened: boolean;
  onClose: () => void;
  recruitments: GetEntryReadyRecommendsResponse['recruitments'];
  basedOnWishIndustries: boolean;
};

export const PostRegisterEntryPromptModal: FC<Props> = ({
  opened,
  onClose,
  recruitments,
  basedOnWishIndustries,
}) => {
  useImpressionGtagEvent({
    eventName: GTAG_EVENT_NAMES.IMP_POST_REGISTER_ENTRY_PROMPT,
    active: opened,
    params: {
      recruitment_count: recruitments.length,
      based_on_wish_industries: basedOnWishIndustries,
    },
  });

  if (recruitments.length === 0) {
    return null;
  }

  return (
    <PromptModal
      opened={opened}
      onClose={onClose}
      componentId={POST_REGISTER_ENTRY_PROMPT_COMPONENT_ID}
    >
      <div className="flex flex-col gap-y-4">
        <Text
          component="h2"
          className="text-md text-black-1 font-bold text-center"
        >
          まずはこの募集にエントリーしませんか？
        </Text>
        <Text className="text-base text-black-2 text-center">
          {basedOnWishIndustries
            ? 'あなたの志望業界で締切が近い募集です'
            : '今エントリーできる募集です'}
        </Text>
      </div>

      <div className="flex flex-col gap-8">
        {recruitments.map((recruitment) => (
          <PostRegisterEntryPromptCard
            key={recruitment.id}
            recruitment={recruitment}
            isQuickEntry={recruitment.isQuickEntry}
            componentId={POST_REGISTER_ENTRY_PROMPT_COMPONENT_ID}
          />
        ))}
      </div>
    </PromptModal>
  );
};
